import ThemeProvider from 'sharedComponents/ThemeProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { Provider } from 'react-redux';
import initializeStore from '../store';
import { FeatureProvider } from './components/FeatureProvider';
import AppContainer from './scenes/App';

const queryClient = new QueryClient();
const store = initializeStore();

const Application = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <FeatureProvider>
          <ThemeProvider>
            <AppContainer />
          </ThemeProvider>
        </FeatureProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  </Provider>
);

export default Application;
